export enum DOCUMENT_FORMAT_TYPE {
  PDF = 'pdf',
  WORD = 'doc',
}
